import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  LucideAngularModule,
  Info, TriangleAlert, CircleCheck, CircleAlert, X,
} from 'lucide-angular';
import { InlineBannerComponent } from './inline-banner.component';

@NgModule({
  declarations: [InlineBannerComponent],
  imports: [
    CommonModule,
    LucideAngularModule.pick({ Info, TriangleAlert, CircleCheck, CircleAlert, X }),
  ],
  exports: [InlineBannerComponent],
})
export class InlineBannerModule {}
